import { t } from '../../../common/i18n/index.js';

// Allows letters (including äöå), digits, whitespace, and: - & ( ) . ,
const ALLOWED_DISPLAY_NAME = /^[a-zA-ZäöåÄÖÅ0-9\s\-&().,]*$/;

const BLOCKED_TERMS: string[] = ['poliisi']; // added poliisi, so sonarlint would accept it.

export const validateCallerDisplayName = (value: string): string | undefined => {
  if (!value) {
    return undefined;
  }
  if (!ALLOWED_DISPLAY_NAME.test(value)) {
    return t.CYRE('Allowed characters: letters, digits, and - & ( ) . ,');
  }

  const lower = value.toLowerCase();
  if (BLOCKED_TERMS.some(term => lower.includes(term))) {
    return t.A90Y('This name is not allowed.');
  }

  return undefined;
};
